<template>
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_194_3187)">
      <path
        d="M3.1 1C2.54305 1 2.0089 1.22125 1.61508 1.61508C1.22125 2.0089 1 2.54305 1 3.1V12.9C1 13.457 1.22125 13.9911 1.61508 14.3849C2.0089 14.7788 2.54305 15 3.1 15H12.9C13.457 15 13.9911 14.7788 14.3849 14.3849C14.7788 13.9911 15 13.457 15 12.9V3.1C15 2.54305 14.7788 2.0089 14.3849 1.61508C13.9911 1.22125 13.457 1 12.9 1H3.1ZM7.5709 4.647C7.70558 4.54252 7.87376 4.49078 8.04388 4.50148C8.21399 4.51217 8.37436 4.58458 8.4949 4.7051L8.553 4.7709C8.65748 4.90558 8.70922 5.07376 8.69852 5.24388C8.68783 5.41399 8.61542 5.57436 8.4949 5.6949L6.8905 7.3H10.8L10.8819 7.3049C11.0591 7.32597 11.2215 7.4139 11.336 7.55072C11.4505 7.68753 11.5085 7.86291 11.498 8.04102C11.4876 8.21913 11.4095 8.38653 11.2798 8.50901C11.15 8.63148 10.9784 8.6998 10.8 8.7H6.8905L8.4949 10.3051L8.553 10.3709C8.66179 10.5116 8.71294 10.6884 8.69608 10.8655C8.67921 11.0425 8.59559 11.2065 8.46219 11.3241C8.3288 11.4417 8.15563 11.5042 7.97787 11.4988C7.8001 11.4933 7.63107 11.4204 7.5051 11.2949L4.7051 8.4949L4.654 8.4375L4.6022 8.3647L4.5658 8.2961L4.535 8.2191L4.514 8.1407L4.5021 8.0525L4.5 8L4.5049 7.9174L4.5252 7.8138L4.5497 7.7403L4.5875 7.6612L4.6372 7.5835C4.65788 7.55574 4.68057 7.52953 4.7051 7.5051L7.5051 4.7051L7.5709 4.647Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_194_3187">
        <rect
          width="16"
          height="16"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>
<script setup lang="ts"></script>
<style lang=""></style>
